import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "password_field", "trigger" ]
  initialize() {
    console.log("Pwinput controller is working!");
  }
  connect() { 
    const field = this.password_fieldTarget;
    const trigger = this.triggerTarget;
    console.log(trigger)
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      field.type === "password" ? field.type = "text" : field.type = "password"
    });
  }
  
}